import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from '../../../cc-base.component';
import {FormRichFieldConfig} from '../../../../model/api/form-rich-field-config';
import {FormFieldConfig} from '../../../../model/api/form-field-config';
import TYPE = FormFieldConfig.TYPE;
import {CcSubFormBaseComponent} from "../cc-sub-form-base.component";

@Component({
  selector: 'cc-map-field[fieldName][formRecordMap]',
  templateUrl: './map-field.component.html',
  styleUrls: ['./map-field.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapFieldComponent extends CcSubFormBaseComponent {

  // @Input()
  formRichFieldConfig: FormRichFieldConfig;

  contextMenuConfig: MenuItem[];

  @Input()
  fieldName: String;

  formRecords: any[] = [];
  @Input()
  formRecordMap: {};
  @Output()
  formRecordMapChange = new EventEmitter<{}>();

  @Input()
  required: boolean;

  @Input()
  disabled: boolean;

  @Input()
  transPartKey: string;

  fieldValueMap = {};

  dialogFormVisible: boolean;
  dialogFormTitle: string = '';

  selectedRecord: any;
  selectedRecords: any[];

  submitted: boolean;
  tableLoading: boolean;

  formRecord: any;
  editedFormRecordCopy: any;

  loadedMap = undefined;

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService,
              private confirmationService: ConfirmationService) {
    super(cdref, messageService, translateService);
  }

  ngOnInit() {
    this.formRichFieldConfig = {
      fieldId: 'key',
      fieldName: 'key',
      tableConfigs: [
        {
          field: 'key',
          width: 200,
        },
        {
          label: '=',
          width: 30
        },
        {
          field: 'value',
          width: 200
        }
      ],
      fields: [
        {
          group: '',
          fields: [
            {
              field: 'key',
              required: true,
              column: 3,
              type: TYPE.TEXT,
            },
            {
              field: 'value',
              column: 9,
              type: TYPE.TEXT
            }]
        }]
    }
    // protected initConfigs() {
    //   super.initConfigs();
    this.contextMenuConfig = [
      {
        label: this.getTranslation('common.table.edit_button'), icon: 'fas fa-pen', command: () => {
          this.edit(this.selectedRecord);
        }
      },
      {
        label: this.getTranslation('common.table.clone_button'), icon: 'fas fa-clone', command: () => {
          this.clone(this.selectedRecord);
        }
      },
      {
        separator: true
      },
      {
        label: this.getTranslation('common.table.delete_button'), icon: 'fas fa-trash-alt', command: () => {
          // // @ts-ignore
          // if (!this.selectedRecords.find(value => value[this.fieldId] === this.formRecord[this.fieldId])) {
          //   this.selectedRecords = [this.formRecord];
          // }
          // this.selectedRecords = [this.formRecord];
          this.delete([this.selectedRecord]);
        }
      }
    ];

    // this.formRecordMapChange.subscribe(value => {
    //   this.loadMap();
    // });
  }

  protected postInitConfigs() {
    super.postInitConfigs();
    this.loadMap();
  }

  openNew() {
    this.dialogFormTitle = this.getTranslation('common.table.create_item') + ' '
      + this.fieldName + 's';
    this.editedFormRecordCopy = undefined;
    this.formRecord = {};
    this.submitted = false;
    this.dialogFormVisible = true;
    this.markForCheck();
  }

  clone(record: any) {
    this.dialogFormTitle = this.getTranslation('common.table.clone_item') + ' '
      + this.fieldName + 's';
    this.editedFormRecordCopy = undefined;
    this.formRecord = JSON.parse(JSON.stringify(record));
    if (this.formRichFieldConfig.fieldId !== this.formRichFieldConfig.fieldName
      && this.formRecord[this.formRichFieldConfig.fieldId]) {
      this.formRecord[this.formRichFieldConfig.fieldId] = undefined;
    }
    if (this.formRecord[this.formRichFieldConfig.fieldName]) {
      this.formRecord[this.formRichFieldConfig.fieldName] = this.formRecord[this.formRichFieldConfig.fieldName] + '_clone';
    }
    this.submitted = false;
    this.dialogFormVisible = true;
    this.markForCheck();
  }

  delete(records: any[]) {
    this.tableLoading = true;
    this.confirmationService.confirm({
      header: this.getTranslation('common.table.delete_item')
        + ' ' + this.getTranslation('page.' + this.transPartKey + '.item_name') + (records.length === 1 ? '' : 's'),
      message: records.length > 1 ? (this.getTranslation('common.dialog.confirm_delete_plu') + ' ' + this.fieldName + 's?')
        : (this.getTranslation('common.dialog.confirm_delete_sing') + ' ' + this.fieldName + '?'),
      icon: 'fas fa-exclamation-triangle',
      acceptLabel: this.getTranslation('common.dialog.delete'),
      acceptButtonStyleClass: 'p-button-danger p-button-sm',
      rejectLabel: this.getTranslation('common.dialog.cancel'),
      rejectButtonStyleClass: 'p-button-warning p-button-sm',
      accept: () => {
        this.formRecords = this.formRecords.filter(val => !records.includes(val));
        this.selectedRecords = undefined;
        this.tableLoading = false;
        this.refreshMap();
        this.reloadFieldValueMap();
      },
      reject: () => {
        this.tableLoading = false;
      }
    });
  }

  edit(record: any) {
    this.dialogFormTitle = this.getTranslation('common.table.edit_item') + ' '
      + this.fieldName + 's';
    this.editedFormRecordCopy = record;
    this.formRecord = JSON.parse(JSON.stringify(record)); // Object.assign({}, record);
    this.dialogFormVisible = true;
    this.markForCheck();
  }

  hideDialog() {
    this.dialogFormVisible = false;
    this.submitted = false;
    this.markForCheck();
  }

  save() {
    this.submitted = true;

    if (this.editedFormRecordCopy) {
      const index = this.formRecords.indexOf(this.editedFormRecordCopy);
      this.formRecords[index] = this.formRecord;

      this.editedFormRecordCopy = undefined;
      this.successMessage(this.fieldName + ' Updated');
    } else {
      this.formRecords.push(this.formRecord);
    }
    this.formRecord = undefined;
    this.dialogFormVisible = false;

    this.refreshMap();
    this.reloadFieldValueMap();
    this.markForCheck();
  }

  onRowRightClick_(record: any) {
  }

  private validateForm(): string {
    if (!this.formRecord) {
      return undefined;
    }
    let message;
    this.formRichFieldConfig.fields.forEach(configGrp => {
      configGrp.fields.forEach(config => {
        if (!message) {
          const fieldMessage = this.validateField(config);
          if (fieldMessage) {
            message = fieldMessage;
          }
        }
      });
    });
    return message;
  }

  private validateField(fieldConfig: FormFieldConfig): string {
    if (!this.formRecord) {
      return '';
    }
    const formRecord = this.formRecord;
    let message;
    if (fieldConfig.required
      && (!this.formRecord[fieldConfig.field] || (this.formRecord[fieldConfig.field] + '').length === 0)) {
      message = this.getTranslation('page.' + this.transPartKey + '.form.' + fieldConfig.field) + ' '
        + this.getTranslation('common.form.required_sing');
    } else if (fieldConfig.validate) {
      message = fieldConfig.validate(this.formRecord);
    } else if (fieldConfig.field === this.formRichFieldConfig.fieldId
      && (!this.editedFormRecordCopy || this.editedFormRecordCopy[fieldConfig.field] !== formRecord[fieldConfig.field])
      && this.formRecords && this.formRecords.filter(function (record) {
        return record[fieldConfig.field] === formRecord[fieldConfig.field];
      }).length > 0) {
      message = this.getTranslation('page.' + this.transPartKey + '.form.' + fieldConfig.field) + ' '
        + this.getTranslation('common.form.must_be_unique');
    }
    return message;
  }

  refreshMap() {
    this.formRecordMap = {};
    this.formRecords.forEach(formRecord => {
      this.formRecordMap[formRecord['key']] = formRecord['value'];
    })
    this.formRecordMapChange.emit(this.formRecordMap);
  }


  loadMap() {
    if (!this.loadedMap || JSON.stringify(this.formRecordMap) != JSON.stringify(this.loadedMap)) {
      this.formRecords = [];
      for (let formRecordMapKey in this.formRecordMap) {
        this.formRecords.push({'key': formRecordMapKey, 'value': this.formRecordMap[formRecordMapKey]});
      }
      this.loadedMap = Object.assign({}, this.formRecordMap);
      // this.formRecords = [...this.formRecords];
    }
  }

  reloadFieldValueMap() {
    this.loadMap();
    this.fieldValueMap = {};
    if (this.formRichFieldConfig && this.formRichFieldConfig.tableConfigs && this.formRecordMap)
      this.formRichFieldConfig.tableConfigs.forEach((conf, index) => {
        if (conf.format && conf.format.includes('#'))
          conf.format = '1.0-7';
        Object.keys(this.formRecordMap).forEach((key, indexRec) => {
          if (conf.mapId) {
            const value = conf.mapId(this.formRecordMap[key]);
            if (value.includes('<'))
              this.fieldValueMap['mapId-' + index + '_' + indexRec] = value;
            this.fieldValueMap['mapId-inner-' + index + '_' + indexRec] = value;
          }
        });
      });
    this.fieldValueMap['validate'] = this.validateForm();
    super.reloadFieldValueMap();
  }
}

